// extracted by mini-css-extract-plugin
export default {"Container":"newPass_Container__pT9Dl","Title":"newPass_Title__uuatx"};